var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input-switch",attrs:{"id":_vm.id,"type":_vm.type,"name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.select($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }